"use client";

import HeaderAutoComplete from "component/header/header-autocomplete.component";
import dynamic from "next/dynamic";
import { useRef } from "react";
import HideIf from "util/HideIf";
import styles from "./headerMobile.module.scss";

const CustomSlideMenu = dynamic(() => import(/* webpackChunkName: "custom-slide-menu" */ "../../component/header/customSlideMenu.component"));

function HeaderMobile(props: any) {
  const {
    liveChat, auth, chat,
    onHideSlideMenu, showSlideMenu,
  } = props;
  const mobileHeaderRef = useRef();

  return (
    <>
      <div className={`${styles.header_mobile} container-fluid p-lr-0-xs header`}>
        <div className="p-l-5 p-r-5 text-center search-box border" style={{ width: "100%" }} ref={mobileHeaderRef}>

          <HeaderAutoComplete liveChat={liveChat} />
        </div>
      </div>
      <HideIf show={showSlideMenu}>
        <CustomSlideMenu
          show={showSlideMenu}
          onHide={onHideSlideMenu}
          auth={auth}
          chat={chat}
        />
      </HideIf>
    </>
  );
}

export default HeaderMobile;
